module.exports = __webpack_public_path__ + "static/media/student-study-next.ff144590.png";